export const initialState = () => ({
  prescriptionRules: [],
  previousRecommendation: {
    id: '',
    heartRate: '',
    heartRateCooldown: '',
    intensityLabel: '',
    frequencyLabel: '',
    sessionDurationLabel: '',
    programDurationLabel: '',
    additionalTrainingStrategies: '',
  },
  recommendation: {
    id: '',
    heartRate: '',
    heartRateCooldown: '',
    intensityLabel: '',
    intensities: [],
    minFrequency: null,
    maxFrequency: null,
    frequencyFlags: [],
    frequencyLabel: '',
    minSessionDuration: null,
    maxSessionDuration: null,
    sessionDurationLabel: '',
    sessionDurationFlags: [],
    minProgramDuration: null,
    maxProgramDuration: null,
    programDurationFlags: [],
    programDurationLabel: '',
    strengthTrainingFlags: [],
    additionalTrainingStrategies: '',
    changeReason: '',
    changed: false,
    hasHIT: false,
  },
  vanillaRecommendation: null, // a JSON string representation of the last algorithm calculation recommendation result
  startRecommendationNextWeek: true,
  defaultRules: [],
  selectedRules: [],
  hrAtrialFibrilationProvoked: '',
  hrMyocardialIschemicTreshold: '',
  hrVentricularTachycardia: '',
  hrICDTreshold: '',
  isRecommendationSaved: false,
  history: {
    prescriptions: [],
    selectedPrescriptionId: '',
    selectedPrescriptionPatientSummary: {},
  },
  recommendationUpdatedByAlgorithm: false,
  recommendationReverted: false,
  recommendationIsOpen: false
});

export const intensity = () => ({
  min: '',
  max: '',
  flags: [],
});

export default initialState();
